module.exports = __webpack_public_path__ + "static/media/twitter.e512a18f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/twitter.png
// module id = 30
// module chunks = 0